<template>
  <div>
    <div style="max-width: 525px" v-if="verificationStatus == 1">
      <v-alert :type="alertType" dense text border="left">
        {{ alertMessage }}
      </v-alert>
    </div>
    <div v-if="verificationStatus == 0">
      <span>{{ $t("verification.email.descriptionVerify.text1") }}</span>
      <br />
      <span>{{ $t("verification.email.descriptionVerify.text2") }}</span>
      <br v-if="!$vuetify.breakpoint.smAndDown" />
      <span>{{ $t("verification.email.descriptionVerify.text3") }}</span>
      <br /><br />
      <span class="text-subtitle-1">
        {{ $t("verification.email.tipVerify.title") }}
      </span>
      <ul>
        <li>{{ $t("verification.email.tipVerify.tip1") }}</li>
        <li>{{ $t("verification.email.tipVerify.tip2") }}</li>
        <li>{{ $t("verification.email.tipVerify.tip3") }}</li>
        <li>{{ $t("verification.email.tipVerify.tip4") }}</li>
      </ul>
      <v-btn
        class="mt-6"
        color="primary"
        :block="$vuetify.breakpoint.smAndDown"
        :loading="loadingBtn"
        :disabled="disableResendConfirmation"
        @click="resendEmail"
        style="text-transform: none;"
      >
        {{ $t("verification.email.btnResendVerify") }}
        <span
          v-if="count <= 59 && loadingBtn === false"
          class="ml-1 overline"
          >{{ count }}</span
        >
      </v-btn>
    </div>
  </div>
</template>

<script>
// Valor inicial do contador resend email
const COUNTER_MAX = 60;

export default {
  name: "EmailVerification",
  props: {
    verificationStatus: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    count: COUNTER_MAX,
    resendEmailCounter: null,
    disableResendConfirmation: false,
    loadingBtn: false,
  }),
  mounted() {
    const storageResendEmailCounter = localStorage.getItem(
      "resendEmailCounter"
    );

    if (storageResendEmailCounter && storageResendEmailCounter > Date.now()) {
      this.count = Math.floor((storageResendEmailCounter - Date.now()) / 1000);
      this.disableResendConfirmation = true;
    } else {
      clearInterval(this.resendEmailCounter);
      this.count = COUNTER_MAX;
    }
  },
  watch: {
    disableResendConfirmation(val) {
      if (val && this.count > 1) {
        this.resendEmailCounter = setInterval(this.counter, 1000);
      } else {
        clearInterval(this.resendEmailCounter);
      }
    },
    verificationStatus(val) {
      if (val) {
        clearInterval(this.resendEmailCounter);
        this.disableResendConfirmation = false;
        this.count = COUNTER_MAX;
      }
    },
  },
  computed: {
    alertMessage() {
      const map = {
        1: this.$t("verification.email.successMessage"),
      };

      return map[this.verificationStatus];
    },
    alertType() {
      const map = {
        1: "success",
      };

      return map[this.verificationStatus];
    },
  },
  methods: {
    // Reenvia o email de confirmação
    resendEmail() {
      this.loadingBtn = true;
      this.disableResendConfirmation = true;

      localStorage.setItem("resendEmailCounter", Date.now() + 60000);

      const data = {
        domain: this.$domain(),
        email: this.userEmail,
        login: localStorage.getItem("currentUserLogin"),
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
      };

      this.$axios
        .post("player/register/resendEmail", this.$formdata(data))
        .then((resp) => {
          const msg = resp.data.messages;
          const color = "success";

          this.$store.commit("setNotification", {
            msg,
            color,
          });
        })
        .catch((err) => {
          const msg = err.response.data.messages.error;
          const color = "warning";

          this.$store.commit("setNotification", {
            msg,
            color,
          });

          localStorage.setItem("resendEmailCounter", Date.now());
          this.count = COUNTER_MAX;

          // this.$emit("changeEmailVerificationStatus");
          this.disableResendConfirmation = false;
        })
        .finally(() => (this.loadingBtn = false));
    },
    counter() {
      if (this.count == 3) {
        this.$emit("changeEmailVerificationStatus");
      }

      if (this.count == 1) {
        clearInterval(this.resendEmailCounter);
        this.disableResendConfirmation = false;
        this.count = COUNTER_MAX;
      } else {
        this.count -= 1;
      }
    },
  },
};
</script>
